import DOMPurify from 'dompurify';

/** Opciones compartidas para `contenido_html` de noticias (cliente). */
export const NOTICIA_CONTENIDO_PURIFY = {
  ALLOWED_TAGS: ['h2', 'h3', 'h4', 'p', 'a', 'strong', 'em', 'ul', 'ol', 'li', 'br', 'blockquote'],
  ALLOWED_ATTR: ['href', 'target', 'rel'],
};

/**
 * HTML de artículos (Gemini/n8n). Solo etiquetas/atributos permitidos antes de dangerouslySetInnerHTML.
 */
export function sanitizeArticleHtml(dirty) {
  return DOMPurify.sanitize(String(dirty ?? ''), NOTICIA_CONTENIDO_PURIFY);
}
